
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.818 9.963C14.565 6.73 22 6.491 22 13.058V21.5h-4.157v-6.999c0-4.21-5.024-3.892-5.024 0V21.5H8.68V8.167h4.14zM6.166 8.167V21.5H2V8.167h4.167zM4.083 2.333c1.142 0 2.067.934 2.067 2.084S5.225 6.5 4.083 6.5a2.076 2.076 0 01-2.067-2.083c0-1.15.926-2.084 2.067-2.084z","fill":"#0073B1"}})])
          )
        }
      }
    